import { KeyOption } from "@/types/defs/keyOption";

const chromaticIs = [...Array(12).keys()];
const majorIs = [0, 2, 4, 5, 7, 9, 11];
// musicologists can debate this :-D
const minorIs = [0, 2, 3, 5, 7, 8, 10];
const makeKey = (a: number[], i: number) =>
  [...Array(20).keys()]
    .map((x) => x * 12 + i)
    .map((x) => a.map((y) => x + y))
    .flat()
    .flat();

const makeKeys = (a: number[]) =>
  [...Array(12).keys()].map((i) => makeKey(a, i));
const majorKeys: number[][] = makeKeys(majorIs);
const minorKeys: number[][] = makeKeys(minorIs);
const chromaticScale = makeKey(chromaticIs, 0);
type KeyStore = {
  [K in KeyOption]: number[];
};

// Lives outside PitchCorrection.tsx so server code (the harmonies API) can resolve a key's notes without importing the editor component, which a server route cannot load.
export const keyStore = (custom: number[]): KeyStore => ({
  Custom: custom,
  "No Key": chromaticScale,
  "C Maj": majorKeys[0],
  "C Min": minorKeys[0],
  "C# Maj": majorKeys[1],
  "C# Min": minorKeys[1],
  "D Maj": majorKeys[2],
  "D Min": minorKeys[2],
  "D# Maj": majorKeys[3],
  "D# Min": minorKeys[3],
  "E Maj": majorKeys[4],
  "E Min": minorKeys[4],
  "F Maj": majorKeys[5],
  "F Min": minorKeys[5],
  "F# Maj": majorKeys[6],
  "F# Min": minorKeys[6],
  "G Maj": majorKeys[7],
  "G Min": minorKeys[7],
  "G# Maj": majorKeys[8],
  "G# Min": minorKeys[8],
  "A Maj": majorKeys[9],
  "A Min": minorKeys[9],
  "A# Maj": majorKeys[10],
  "A# Min": minorKeys[10],
  "B Maj": majorKeys[11],
  "B Min": minorKeys[11],
});
